export class SearchRequest {
    searchText: string;
}
